import { OnSetup } from "@hooks/useAppSetup/types";
import { createWithEqualityFn } from "zustand/traditional";

type AppSetupState = {
  // Local SQLite migrations completed. Deliberately separate from
  // downloadManagerIsSetup: the offline-access lease only needs the local
  // DB, and must not be disabled by a download-manager startup failure.
  sqliteIsReady: boolean;
  downloadManagerIsSetup: boolean;
  focusSubscriptionIsSetup: boolean;
  inAppUpdatesIsSetup: boolean;
  intercomIsSetup: boolean;
  lUpdatesIsSetup: boolean;
  revenueCatIsSetup: boolean;
  setSqliteIsReady: OnSetup;
  setDownloadManagerIsSetup: OnSetup;
  setFocusSubscriptionIsSetup: OnSetup;
  setInAppUpdatesIsSetup: OnSetup;
  setIntercomIsSetup: OnSetup;
  setLUpdatesIsSetup: OnSetup;
  setRevenuecatIsSetup: OnSetup;
};

export const useAppSetupStore = createWithEqualityFn<AppSetupState>((set) => ({
  sqliteIsReady: false,
  downloadManagerIsSetup: false,
  focusSubscriptionIsSetup: false,
  inAppUpdatesIsSetup: false,
  intercomIsSetup: false,
  lUpdatesIsSetup: false,
  revenueCatIsSetup: false,
  setSqliteIsReady: (value: boolean) => set({ sqliteIsReady: value }),
  setDownloadManagerIsSetup: (value: boolean) =>
    set({ downloadManagerIsSetup: value }),
  setFocusSubscriptionIsSetup: (value: boolean) =>
    set({ focusSubscriptionIsSetup: value }),
  setInAppUpdatesIsSetup: (value: boolean) =>
    set({ inAppUpdatesIsSetup: value }),
  setIntercomIsSetup: (value: boolean) => set({ intercomIsSetup: value }),
  setLUpdatesIsSetup: (value: boolean) => set({ lUpdatesIsSetup: value }),
  setRevenuecatIsSetup: (value: boolean) => set({ revenueCatIsSetup: value }),
}));

export const revenueCatIsSetup = () =>
  useAppSetupStore.getState().revenueCatIsSetup;
